module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Burgundy_Twisted_Roots2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center1"
  }, [_vm._v("“Those cries rose from among the twisted roots "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("through which the spirit of the damned "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("were slinking to hide from us….”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Dante Alighieu")])]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f292ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Burgundy_Twisted_Roots5.vue
// module id = 75
// module chunks = 0